import { BreakpointsOptions } from '@material-ui/core/styles/createBreakpoints';

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 640,
    md: 960,
    lg: 1200,
    xl: 1600
  },
};

export default breakpoints;
